package er.prateek.crossly.content

import crossly.shared.generated.resources.Res
import er.prateek.crossly.data.model.WordBank
import kotlinx.serialization.json.Json

private const val WORD_BANK_PATH = "files/wordbank/wordbank-en-v1.json"

private val wordBankJson = Json { ignoreUnknownKeys = true }

/**
 * Loads the bundled word bank. Parsing ~11k entries is not free, so the result
 * is held for the process lifetime: the bank is immutable content, and every
 * caller wants the same copy.
 */
class WordBankSource(private val resourcePath: String = WORD_BANK_PATH) {
    private var cached: WordBank? = null

    suspend fun load(): WordBank {
        cached?.let { return it }
        val bytes = Res.readBytes(resourcePath)
        return wordBankJson
            .decodeFromString(WordBank.serializer(), bytes.decodeToString())
            .also { cached = it }
    }
}
